/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { kGroupFuncTypes } from '../../constants';

const propTypes = {
  value: React.PropTypes.string.isRequired,
  onSelect: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class GroupByFuncButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.groupbys.funcs');
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  render() {
    const { onSelect } = this.props;
    const { value } = this.state;
    return (
      <DropdownButton
        id="group-by-func"
        bsStyle="aisz-func"
        title={this.intlMsg.msg(value)}
        onSelect={onSelect}
        pullRight
      >
        {kGroupFuncTypes.map(func => (
          <MenuItem key={func} eventKey={func}>
            {this.intlMsg.msg(func)}
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }
}

GroupByFuncButton.propTypes = propTypes;

export default injectIntl(GroupByFuncButton);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/GroupByFuncButton/index.jsx